import { render, staticRenderFns } from "./CompanyFormBtn.vue?vue&type=template&id=d576c4c8&scoped=true&"
import script from "./CompanyFormBtn.vue?vue&type=script&lang=js&"
export * from "./CompanyFormBtn.vue?vue&type=script&lang=js&"
import style0 from "./CompanyFormBtn.vue?vue&type=style&index=0&id=d576c4c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d576c4c8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VDialog,VIcon})
